import type { CallStatus } from '../types';

export const ACTIVE_CALL_STATUSES = [
  'pending',
  'queued',
  'dialing',
  'analyzing',
  'ringing',
  'in_progress',
] as const satisfies readonly CallStatus[];

export const INTERMEDIARY_CALL_STATUSES = [
  'finalizing',
] as const satisfies readonly CallStatus[];

